module.exports = __webpack_public_path__ + "static/media/draw.7e7b76e8.mp3";